import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { Form } from 'formik';
import Spacer from 'components/Shared/Spacer';
import { LargeButton, ButtonState } from 'components/Shared/Buttons';
import useEvents from 'lib/hooks/useEvents';
import VdpEventContext from 'contexts/VdpEventContext';
import tapEvent from 'lib/Tracking/LeadForm/TapEvent';
import { colors } from 'components/styles/variables';
import LeadFormTrackingContext from 'components/Vdp/LeadFormTrackingContext';
import { LeadSubmission } from 'lib/hooks/useSubmitted';
import styles, { formStyles } from './styles';
import { SubmissionState } from './FormManager';
import FieldSet from './FieldSet';
import Terms from './Terms';

interface LeadFormProps {
  dealerPhone?: string | null;
  showZipCode?: boolean;
  showAddress?: boolean;
  isSubmitted: boolean;
  submissionState: SubmissionState;
  formInputClassName?: string;
  submitButtonContainerClassName?: string;
  marginClassName?: string;
  leadSubmission: LeadSubmission;
}

export default function FormComponent({
  dealerPhone,
  showZipCode,
  showAddress,
  formInputClassName = '',
  submitButtonContainerClassName = '',
  isSubmitted,
  submissionState,
  marginClassName = '',
  leadSubmission,
}: LeadFormProps): JSX.Element {
  const { t } = useTranslation();
  const eventData = useContext(LeadFormTrackingContext);

  function submitButtonState(): ButtonState {
    switch (submissionState) {
      case SubmissionState.submitted:
        return ButtonState.disabled;
      case SubmissionState.submitting:
        return ButtonState.thinking;
      default:
        return ButtonState.normal;
    }
  }

  const logger = useEvents();

  const { trackingParams } = useContext(VdpEventContext);
  return (
    <>
      <Form className={`form ${formStyles.className}`} noValidate={true}>
        <FieldSet
          showZipCode={showZipCode}
          showAddress={showAddress}
          isSubmitted={isSubmitted}
          formInputClassName={formInputClassName}
          marginClassName={marginClassName}
          leadSubmission={leadSubmission}
        />

        <Spacer size="16px" />
        {dealerPhone && <div className="call">{`${t('leadForm.call')} ${dealerPhone}`}</div>}
        <Spacer size="16px" />

        <div className={submitButtonContainerClassName}>
          <LargeButton
            data-testid="submit"
            normalText={t('leadForm.sendRequest')}
            disabledText={t('leadForm.contacted')}
            className="vdp-submit-button"
            state={submitButtonState()}
            type="submit"
            onClick={(): void => {
              logger.log(tapEvent({ action: 'lead_form_submit', trackingParams, ...eventData }));
            }}
          />
        </div>

        <Spacer size="16px" />
        <Terms />
      </Form>
      {formStyles.styles}
      <style jsx>{`
        .call {
          width: 100%;
          text-align: center;
          font-size: 16px;
          font-weight: 300;
          color: ${colors.BLACK};
        }
      `}</style>
      <style jsx>{styles}</style>
    </>
  );
}
